import { defineComponent, computed } from "vue";
import { V as VaAvatar } from "../va-avatar/index-9299ef14.mjs";
import { p as pick } from "../../../vendor-2b2dbafd.mjs";
import { e as extractComponentProps } from "../../utils/component-options/extract-component-options-6b96d215.mjs";
import { u as useSizeProps, a as useSize } from "../../composables/useSize-a4b897f3.mjs";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset-0dfbd395.mjs";
import { u as useBem } from "../../composables/useBem-33d80128.mjs";
import { f as filterComponentProps } from "../../utils/component-options/filter-props-9727421a.mjs";
const VaAvatarProps = extractComponentProps(VaAvatar);
const _sfc_main = defineComponent({
  name: "VaAvatarGroup",
  components: {
    VaAvatar
  },
  props: {
    ...useSizeProps,
    ...useComponentPresetProp,
    ...VaAvatarProps,
    max: {
      type: Number,
      default: void 0
    },
    vertical: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    /** If there are more avatars that can be displayed we show rest number. This prop changes color of rest indicator. */
    restColor: {
      type: String,
      default: "secondary"
    }
  },
  setup(props) {
    const classComputed = useBem("va-avatar-group", () => ({
      ...pick(props, ["vertical"])
    }));
    const maxOptions = computed(() => props.options.slice(0, props.max));
    const visibleItemsCount = computed(() => props.max ? props.max + 1 : 1);
    const restOptionsCount = computed(() => props.options.length - (props.max || 0));
    const { sizeComputed, fontSizeComputed } = useSize(props, "VaAvatarGroup");
    const filteredAvatarProps = filterComponentProps(VaAvatarProps);
    const avatarProps = computed(() => ({
      ...filteredAvatarProps.value,
      fontSize: fontSizeComputed.value,
      size: sizeComputed.value
    }));
    return {
      classComputed,
      maxOptions,
      visibleItemsCount,
      restOptionsCount,
      avatarProps
    };
  }
});
export {
  _sfc_main as _
};

import '../../../VaAvatarGroup.css';
//# sourceMappingURL=VaAvatarGroup.vue_vue_type_script_lang-68df8853.mjs.map
